import { NgModule } from "@angular/core";
import { CommonModule} from '@angular/common';

import {ComponentComment} from "../../../component/comment/component.comment";
import {ComponentEvaluate} from "../../../component/evaluate/component.evaluate";
import {ComponentTab} from "../../../component/tab/component.tab";
import {ComponentTool} from "../../../component/tool/component.tool";
import {SharedModule} from '../../../component/shareModule';


@NgModule({
  imports: [CommonModule, SharedModule],
    declarations:[
        ComponentComment,
        ComponentEvaluate,
        ComponentTab,
        ComponentTool
    ],
    exports:[
        ComponentComment,
        ComponentEvaluate,
        ComponentTab,
        ComponentTool
    ]
})

export class LearningCampRseponseModule{

}




// WEBPACK FOOTER //
// ./src/app/learning-camp/camp-response/learning-camp-response.module.ts